import { Injectable, inject } from "@angular/core";
import { Http, QueryHandlerFor } from "@skylab-angular-shared/core";
import { ConsoleLogger, HttpService, Query, QueryHandler, TaggedUrl, Tags } from "@skylab-shared/core";
import { fillPlaceholders } from "@skylab-shared/utils";

export interface PurchaseEInvoiceGetConvertedXmlQueryParams {
    documentId: number;
}

export interface PurchaseEInvoiceGetConvertedXmlQueryResult {
    readonly contact?: {
        readonly email?: string;
        readonly phoneNumber?: string;
    }[],
    readonly bankAccounts? :{
        readonly bankName?: string;
        readonly bankAccountNumber?: string;
    }[]
}

export class PurchaseEInvoiceGetConvertedXmlQuery extends Query<PurchaseEInvoiceGetConvertedXmlQueryResult | undefined> {
    public constructor(public readonly params: PurchaseEInvoiceGetConvertedXmlQueryParams) {
        super();
    }
}


@Injectable({ providedIn: 'root'})
@QueryHandlerFor(PurchaseEInvoiceGetConvertedXmlQuery)
export class PurchaseEInvoiceGetConvertedXmlQueryHandler implements QueryHandler<PurchaseEInvoiceGetConvertedXmlQuery> {
    #Url = TaggedUrl.join('purchase/eInvoice/:id/xmlConverted', [Tags.Api]);
    #http = inject(Http) as HttpService;
    #logger = new ConsoleLogger(this.constructor.name);

    public async handleAsync({ params }: PurchaseEInvoiceGetConvertedXmlQuery): Promise<PurchaseEInvoiceGetConvertedXmlQueryResult | undefined> {
        try {
            const url = fillPlaceholders(this.#Url, { id: params.documentId });
            const { data } = await this.#http.get(url);

            return data;
        } catch (err) {
            this.#logger.error(err);
        }

        return undefined;
    }
}
